import { svgViewBoxSize } from "@/lib/svgRasterize";
import { SvgPngExportPanel } from "./SvgPngExportPanel";

interface SvgSettingsPanelProps {
  /** Fully substituted SVG source. */
  svg: string;
  /** Filename stem for downloads (no extension). */
  fileBase: string;
}

/**
 * The "Settings" tab for SVG projects. Shows a read-only Canvas readout (the
 * viewBox size — SVG has no editable native canvas, the artboard is defined by
 * the source's viewBox) above the PNG/SVG export panel.
 *
 * Owns no hooks of its own (SvgPngExportPanel owns its scale/busy/error state),
 * so it's safe to mount inside a tab pane below a parent's early returns.
 */
export function SvgSettingsPanel({ svg, fileBase }: SvgSettingsPanelProps) {
  const dims = svg ? svgViewBoxSize(svg) : null;

  return (
    <div className="flex w-full max-w-[420px] flex-col gap-6 text-xs text-ink">
      {/* Canvas — read-only viewBox readout. */}
      <section className="flex flex-col gap-2">
        <label className="text-xs font-medium text-ink-2">Canvas</label>
        <div className="rounded-lg border border-line bg-surface px-3 py-2 text-xs text-ink">
          {dims ? (
            <>
              {dims.width} × {dims.height} px{" "}
              <span className="text-ink-3">(viewBox)</span>
            </>
          ) : (
            <span className="text-ink-3">
              No viewBox — canvas size unavailable.
            </span>
          )}
        </div>
      </section>

      <SvgPngExportPanel svg={svg} fileBase={fileBase} />
    </div>
  );
}
